import { useState } from 'react';
import styles from './styles.module.scss';
import { InputStyle } from 'components/InitialStyle';
import { InputAdornment, OutlinedInput, IconButton } from '@mui/material';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { Controller } from 'react-hook-form';

const PasswordGenerator = ({
  label,
  name,
  password,
  error,
  control,
  show,
  setShow,
  type,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClick = () => {
    setShowPassword((prev) => !prev);
  };

  const validateLength = (value) => {
    if (value?.length < 8) {
      return 'Поле должно содержать не менее 8 символов';
    }
    return true;
  };

  return (
    <div className={styles.root}>
      <div className={styles.label}>
        <h6 className={styles.left}>{label}</h6>
        {type === 'edit' ? (
          <h6 onClick={() => setShow(true)} className={styles.right}>
            изменить
          </h6>
        ) : (
          ''
        )}
      </div>

      <div className={styles.box}>
        <Controller
          name={name}
          control={control}
          rules={{
            required: show ? 'Поле, обязательное для заполнения' : false,
            validate: { validate: validateLength },
          }}
          render={({ field }) => (
            <OutlinedInput
              disabled={show === false}
              {...field}
              id={name}
              value={field.value || password}
              type={showPassword ? 'text' : 'password'}
              sx={{ borderColor: 'red', ...InputStyle }}
              error={Boolean(error?.[name])}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    placeholder='********'
                    sx={{ marginLeft: '5px' }}
                    disableRipple
                    onClick={handleClick}
                    edge='end'
                  >
                    {showPassword ? (
                      <AiFillEye size={24} />
                    ) : (
                      <AiFillEyeInvisible size={24} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
          )}
        />
      </div>
      {error?.[name]?.type === 'required' && (
        <small style={{ color: 'red', fontSize: '11px' }}>
          {error[name].message}
        </small>
      )}
      {error?.[name]?.type === 'validate' && (
        <small style={{ color: 'red', fontSize: '11px' }}>
          {error[name].message}
        </small>
      )}
    </div>
  );
};

export default PasswordGenerator;
